// src/Apis/BookingsApi.js
import axios from "axios";
import apiUrlOne from "../Config";

// Get all bookings with optional filters
export const getAllBookings = async (filters = {}) => {
    try {
        const response = await axios.post(`${apiUrlOne}/booking/getallBookings`, filters);
        return response.data; // { bookings: [...], totalPages, totalItems, page }
    } catch (error) {
        console.error("Error fetching bookings:", error);
        throw error;
    }
};

// Get booking by ID
export const getBookingById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/booking/getbooking/${id}`);
        return response.data; // { booking: { ... } }
    } catch (error) {
        console.error("Error fetching booking details:", error);
        throw error;
    }
};
